import { setHtml } from './css.js';
import { mountPopup } from './grid-util.js';
import { buildPrintHtml, printHtml, PAPER_MM } from './print.js';
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
export function openPrintSetup(grid, init = {}, opts = {}) {
    const all = grid.printColumns();
    const t = grid.t;
    let o = { paper: 'A4', orientation: 'portrait', fontSize: 8.5, fitWidth: true, scale: 100, margin: 12, ...init };
    let order = (o.columns ?? all.map(c => c.id)).slice();
    const on = new Set(order);
    for (const c of all)
        if (!order.includes(c.id))
            order.push(c.id);
    const approvalsDefault = init.approvals?.length ? init.approvals : [t('담당'), t('검토'), t('승인')];
    let appr = !!init.approvals?.length;
    return new Promise(resolve => {
        const back = document.createElement('div');
        back.className = 'og-psb';
        setHtml(back, `<div class="og-ps" role="dialog" aria-modal="true" aria-label="${t('인쇄 페이지 설정')}">
<div class="og-psf">
  <h3>${t('페이지 설정')}</h3>
  <label>${t('용지')} <select data-k="paper" aria-label="${t('용지')}">${['A4', 'A3', 'B5', 'Letter'].map(p => `<option${p === o.paper ? ' selected' : ''}>${p}</option>`).join('')}</select></label>
  <fieldset><legend>${t('방향')}</legend><label><input type="radio" name="og-ps-or" value="portrait"${o.orientation !== 'landscape' ? ' checked' : ''}> ${t('세로')}</label><label><input type="radio" name="og-ps-or" value="landscape"${o.orientation === 'landscape' ? ' checked' : ''}> ${t('가로')}</label></fieldset>
  <label>${t('여백(mm)')} <input type="number" data-k="margin" min="0" max="40" value="${typeof o.margin === 'number' ? o.margin : 12}" aria-label="${t('여백')}"></label>
  <label>${t('글자 크기(pt)')} <input type="number" data-k="fontSize" min="6" max="16" step="0.5" value="${o.fontSize}" aria-label="${t('글자 크기')}"></label>
  <label><input type="checkbox" data-k="fitWidth"${o.fitWidth !== false ? ' checked' : ''}> ${t('용지 너비에 맞춤')}</label>
  <label><input type="checkbox" data-k="pageBreakPerGroup"${o.pageBreakPerGroup ? ' checked' : ''}> ${t('그룹마다 새 쪽')}</label>
  <label>${t('배율(%)')} <input type="number" data-k="scale" min="30" max="200" step="5" value="${o.scale}" aria-label="${t('배율')}"></label>
  <label>${t('제목')} <input data-k="title" value="${esc(o.title ?? '')}" aria-label="${t('제목')}"></label>
  <label>${t('머리말')} <input data-k="headerText" value="${esc(o.headerText ?? '')}" aria-label="${t('머리말')}"></label>
  <label>${t('꼬리말')} <input data-k="footerText" value="${esc(o.footerText ?? '')}" aria-label="${t('꼬리말')}"></label>
  <label><input type="checkbox" data-k="appr"${appr ? ' checked' : ''}> ${t('결재란')} (${esc(approvalsDefault.join('·'))})</label>
  <div class="og-pscols" role="group" aria-label="${t('인쇄 컬럼과 순서')}"></div>
  <div class="og-psbtn"><button type="button" data-a="print" class="og-rok">${t('인쇄')}</button><button type="button" data-a="close">${t('닫기')}</button></div>
</div>
<div class="og-psv"><div class="og-psinfo" aria-live="polite"></div><iframe title="${t('인쇄 미리보기')}" class="og-psframe"></iframe></div>
</div>`);
        mountPopup(grid, back, opts.container);
        const $ = (sel) => back.querySelector(sel);
        const frame = $('.og-psframe');
        const colsBox = $('.og-pscols');
        const drawCols = () => {
            setHtml(colsBox, `<div class="og-psh">${t('컬럼 (체크·순서)')}</div>` + order.map((id, i) => {
                const c = all.find(x => x.id === id);
                return `<div class="og-psc"><label><input type="checkbox" data-c="${esc(id)}"${on.has(id) ? ' checked' : ''}> ${esc(c.header)}</label><button type="button" data-up="${i}" aria-label="${esc(t('{col} 위로', { col: c.header }))}"${i ? '' : ' disabled'}>↑</button><button type="button" data-dn="${i}" aria-label="${esc(t('{col} 아래로', { col: c.header }))}"${i < order.length - 1 ? '' : ' disabled'}>↓</button></div>`;
            }).join(''));
        };
        let html = '';
        const update = () => {
            const val = (k) => back.querySelector(`[data-k="${k}"]`);
            o = {
                ...o,
                paper: val('paper').value,
                orientation: (back.querySelector('input[name="og-ps-or"]:checked')?.value ?? 'portrait'),
                margin: Math.max(0, +val('margin').value || 0), fontSize: +val('fontSize').value || 8.5,
                fitWidth: val('fitWidth').checked, pageBreakPerGroup: val('pageBreakPerGroup').checked, scale: +val('scale').value || 100,
                title: val('title').value, headerText: val('headerText').value || undefined, footerText: val('footerText').value || undefined,
                columns: order.filter(id => on.has(id)),
            };
            appr = val('appr').checked;
            o.approvals = appr ? approvalsDefault : undefined;
            html = buildPrintHtml(grid, o);
            frame.srcdoc = html;
            const [w, h] = PAPER_MM[o.paper ?? 'A4'];
            const pw = o.orientation === 'landscape' ? h : w, ph = o.orientation === 'landscape' ? w : h;
            // 미리보기 틀을 용지 비율로 (가로 520px 기준)
            frame.style.width = '520px';
            frame.style.height = Math.round(520 * ph / pw) + 'px';
            frame.style.setProperty('--zoom', String(520 / (pw * 96 / 25.4)));
            $('.og-psinfo').textContent = `${o.paper} ${t(o.orientation === 'landscape' ? '가로' : '세로')} · ${pw}×${ph}mm · ${t('컬럼 {n}개', { n: o.columns.length })} · ${t('여백')} ${o.margin}mm · ${o.fontSize}pt${o.fitWidth ? ' · ' + t('너비 맞춤') : ''}`;
        };
        frame.addEventListener('load', () => { try {
            const d = frame.contentDocument;
            d.documentElement.style.zoom = frame.style.getPropertyValue('--zoom');
        }
        catch { /* 무시 */ } });
        drawCols();
        update();
        back.addEventListener('input', e => { const t = e.target; if (t.dataset.c) {
            t.checked ? on.add(t.dataset.c) : on.delete(t.dataset.c);
        } update(); });
        back.addEventListener('change', () => update());
        const done = (r) => { back.remove(); resolve(r); };
        back.addEventListener('click', e => {
            const b = e.target.closest('button');
            if (!b)
                return;
            if (b.dataset.up || b.dataset.dn) {
                const i = +(b.dataset.up ?? b.dataset.dn), j = b.dataset.up ? i - 1 : i + 1;
                [order[i], order[j]] = [order[j], order[i]];
                drawCols();
                update();
                colsBox.querySelector(`[data-${b.dataset.up ? 'up' : 'dn'}="${j}"]`)?.focus();
            }
            else if (b.dataset.a === 'print') {
                const r = { options: o, html };
                if (opts.print !== false)
                    printHtml(html);
                done(r);
            }
            else if (b.dataset.a === 'close')
                done(null);
        });
        back.addEventListener('keydown', e => { if (e.key === 'Escape') {
            e.stopPropagation();
            done(null);
        } });
        back.querySelector('[data-k="paper"]').focus();
    });
}
